export function daysUntil(dstr) {
  if (!dstr) return null;
  const d = new Date(dstr);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / 86400000);
}

export function expiryStatus(dstr) {
  const days = daysUntil(dstr);
  if (days === null) return "sin_fecha";
  if (days < 0) return "caducado";
  if (days <= 30) return "proximo";
  return "vigente";
}

export const STATUS_META = {
  caducado: { label: "Caducado", cls: "bg-red-100 text-red-800 border border-red-200" },
  proximo: { label: "Próximo", cls: "bg-amber-100 text-amber-800 border border-amber-200" },
  vigente: { label: "Vigente", cls: "bg-emerald-100 text-emerald-800 border border-emerald-200" },
  sin_fecha: { label: "Sin fecha", cls: "bg-slate-100 text-slate-600 border border-slate-200" },
};

export function fmtDate(dstr) {
  if (!dstr) return "—";
  const d = new Date(dstr);
  if (isNaN(d.getTime())) return dstr;
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function initials(name) {
  return (name || "?")
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();
}
